<template>
  <div class="page-apply">
    <div class="content-wrapper">
      <div class="breadcrumb-wrapper">
        <h-breadcrumb separator=">">
          <h-breadcrumb-item href="/serviceProductAll"
            >组件集市</h-breadcrumb-item
          >
          <h-breadcrumb-item href="../">{{
            service_info.service_name
          }}</h-breadcrumb-item>
          <h-breadcrumb-item>申请单确认</h-breadcrumb-item>
        </h-breadcrumb>
      </div>
    </div>
    <div class="apply-form-wrapper">

      <div class="apply-form">
        <div class="owner-wrap"
          v-if="ownerList.length>1&&ownerList.length>1"
        >

        <div>
          <span class="form-left-label">
            订单归属主体
            <h-tooltip placement="top">
              <div slot="content">
                <p>如果您是为企业购买产品，请选择企业名称，</p>
                <p>如果您是为自己购买产品，请选择个人。</p>
              </div>
              <h-icon name="feedback_fill" size="20"></h-icon>
            </h-tooltip>
          </span>
             <span
            v-for="item in ownerList"
            :key="item.account_id"
            class="owner-item"
            :class="{ 'owner-item-active': item.account_id == owner_account_id }"
            @click="changeOwner(item.account_id, item.account_type)"
            >{{ item.account_name||'' }}<span v-if="item.account_type=='1'">(个人)</span></span
          >
        </div>
      </div>
        <h-form
          ref="formCols"
          :model="formCols"
          :label-width="120"
          cols="2"
          :rules="ruleValidate"
          v-if="isType != 15"
        >
          <h-form-item label="申请产品名称" prop="service_name">
            <h-input
              v-model="formCols.service_name"
              placeholder="请输入"
              style="width: 300px"
              disabled
            ></h-input>
          </h-form-item>
          <h-form-item label="套餐" prop="set_meal_str">
            <h-input
              v-model="formCols.set_meal_str"
              placeholder="请输入"
              style="width: 300px"
              disabled
            ></h-input>
          </h-form-item>
          <h-form-item label="申请描述" prop="app_scene" required cols="2">
            <h-input

              v-model="formCols.app_scene"
              placeholder="请输入你的申请服务的应用场景"
              style="width: 800px"
              :maxlength="100"
            ></h-input>
          </h-form-item>
          <!-- <h-form-item label="申请人" prop="companyContacts" required>
            <h-input
              v-model.trim="formCols.companyContacts"
              placeholder="请输入"
              style="width: 300px"
            ></h-input>
          </h-form-item> -->
          <!-- <h-form-item label="申请部门" prop="department">
            <h-input
              v-model="formCols.department"
              placeholder="请输入"
              style="width: 300px"
            ></h-input>
          </h-form-item> -->
          <!-- <h-form-item label="申请使用时间" required>

            <h-row>
              <h-col span="20">
                <h-col span="11">
                  <h-form-item prop="service_start_time">
                    <h-date-picker
                      type="date"
                      format="yyyy-MM-dd"
                      placeholder="选择日期"
                      v-model="formCols.service_start_time"
                      showFormat
                    ></h-date-picker>
                  </h-form-item>
                </h-col>
                <h-col span="1" style="text-align: center; margin: 0 2px">-</h-col>
                <h-col span="11">
                  <h-form-item prop="service_end_time">
                    <h-date-picker
                      type="date"
                      format="yyyy-MM-dd"
                      placeholder="选择日期"
                      v-model="formCols.service_end_time"
                      showFormat
                      :options="options1"
                    ></h-date-picker>
                  </h-form-item>
                </h-col>
                <h-col span="24">
                  <h-radio-group
                    :canCancel="true"
                    v-model="durationTime"
                    @on-change="changeDurationTime"
                  >
                    <h-radio label="30" :class="durationTime === 30 && 'cur-radio'">一个月</h-radio>
                    <h-radio label="90" :class="durationTime === 90 && 'cur-radio'">三个月</h-radio>
                    <h-radio label="365" :class="durationTime === 365 && 'cur-radio'">一年</h-radio>
                  </h-radio-group>
                </h-col>
              </h-col>
            </h-row>
          </h-form-item> -->
          <!--
          <h-form-item label="申请依据" prop="apply_basis" required v-if="service_info.apply_template_type!='1'">
            <h-select v-model="formCols.apply_basis" style="width: 300px">
              <h-option
                v-for="item in applyBasisList"
                :key="item.dict_item_code"
                :value="item.dict_item_code"
                >{{ item.dict_item_name }}</h-option
              >
            </h-select>
          </h-form-item>
          -->
          <!-- <h-form-item
            label="环境"
            prop="environment"
            :required="formCols.alternation_type == 1"
            v-if="formCols.alternation_type == 1"
          >
            <h-select v-model="formCols.environment" style="width: 300px" @on-change="getCombo">
              <h-option
                v-for="item in envList"
                :value="item.value"
                :key="`addenv${item.value}`"
              >{{ item.label }}</h-option>

            </h-select>
          </h-form-item> -->
          <h-form-item label="合同编号" prop="contract_id" v-if="service_info.apply_template_type!='1'">
            <h-input
              class="showWordLimit"
              v-model="formCols.contract_id"
              placeholder="请输入"
              style="width: 300px"
              :maxlength="50"
              :showWordLimit="true"
            ></h-input>
          </h-form-item>
          <h-form-item label="合同金额" prop="contract_amount" v-if="service_info.apply_template_type!='1'">
            <h-input
              v-model="formCols.contract_amount"
              placeholder="请输入"
              style="width: 300px"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="KEY"
            prop="appkey"
            :required="formCols.alternation_type == 1 && service_info.alternation_id!=='3'"
            v-if="formCols.alternation_type == 1  && service_info.alternation_id!=='3'"
          >
            <h-select v-model="formCols.appkey" style="width: 300px" filterable>
              <h-option
                v-for="item in appkeyList"
                :key="item.app_key"
                :value="item.app_key"
              >
                <span style="border: 1px solid #ccc; padding: 2px"
                  >{{ item.client_name }}：{{ item.app_key }}</span
                >
              </h-option>
              <p
                slot="footer"
                style="color: #0ae; text-align: center; cursor: pointer"
                @click="createKey"
              >
                + 新建KEY
              </p>
            </h-select>
            <!-- <p class="red-tip">注：如果客户的key已存在，请直接粘贴key，系统会自动带出客户信息，无需重复填写！</p> -->
          </h-form-item>
          <!-- <h-form-item label="申请最大TPS" prop="per_value"  :required="formCols.alternation_type==1" v-if="formCols.alternation_type==1">
                    <h-input v-model="formCols.per_value" placeholder="请输入" style="width:300px" :maxlength=6></h-input>
          </h-form-item>-->

          <h-form-item label="添加附件" prop="remark" cols="2">
            <upload-item ref="uploadItem"></upload-item>
            <p class="tip">
              选择文件，允许文件类型:xls、xlsx、doc、docx、rar、zip、png、jpg，且不超过5MB
            </p>
          </h-form-item>
          <h-form-item label="备注" prop="remark" cols="2" v-if="service_info.apply_template_type!='1'">
            <h-input
              v-model="formCols.remark"
              placeholder="请输入"
              type="textarea"
              :showWordLimit="true"
              :maxlength="500"
              style="width: 800px"
            ></h-input>
          </h-form-item>
        </h-form>
        <h-form
          class="formColsMarket"
          ref="formColsMarket"
          :model="formColsMarket"
          :label-width="180"
          cols="2"
          v-else
          :rules="ruleValidateMarket"
        >
          <h-form-item
            label="申请证书类型"
            prop="certificate_type"
            required
            key="certificate_type"
          >
            <h-tooltip
              content="client_license:用于ds服务器，按客户方mac授权，区分业务"
              v-if="formColsMarket.certificate_type == 1"
              style="max-width:200px"
            >
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-tooltip
              content="client_license:用于行情服务器，按客户方mac授权,区分市场"
              v-if="formColsMarket.certificate_type == 2"
            >
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-icon
              name="feedback"
              style="opacity:0"
              v-if="
                formColsMarket.certificate_type != 1 &&
                  formColsMarket.certificate_type != 2
              "
            ></h-icon>
            <h-select
              v-model="formColsMarket.certificate_type"
              style="width: 280px"
              @on-change="changeCertificateType"
              :clearable="false"
            >
              <h-option
                v-for="item in certificateTypeLlist"
                :key="item.id"
                :value="item.id"
                >{{ item.label }}</h-option
              >
            </h-select>
          </h-form-item>
          <h-form-item label="申请描述" prop="app_scene">
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model="formColsMarket.app_scene"
              placeholder="请输入"
              style="width: 280px"
              :maxlength="50"
            ></h-input>
          </h-form-item>
          <!--
           <h-form-item label="申请依据" prop="apply_basis" required>
             <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-select v-model="formColsMarket.apply_basis" style="width: 280px">
              <h-option
                v-for="item in applyBasisList"
                :key="item.dict_item_code"
                :value="item.dict_item_code"
                >{{ item.dict_item_name }}</h-option
              >
            </h-select>
          </h-form-item>
          -->
          <!-- <h-form-item label="申请人" prop="companyContacts" required>
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model.trim="formColsMarket.companyContacts"
              placeholder="请输入"
              style="width: 280px"
            ></h-input>
          </h-form-item> -->
          <!-- <h-form-item label="申请部门" prop="department">
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model="formColsMarket.department"
              placeholder="请输入"
              style="width: 280px"
            ></h-input>
          </h-form-item> -->
          <!-- <h-form-item
            label="申请人邮箱"
            prop="applicant_email"
            required
            key="applicant_email"
          >
            <h-tooltip
              content="我们强烈建议您填写制作人的邮箱，便于接收证书到期提醒"
            >
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.applicant_email"
              placeholder="请输入"
              style="width: 280px"
              :maxlength="50"
            ></h-input>
          </h-form-item> -->
          <!-- <h-form-item
            label="对接工程邮箱"
            prop="maintain_email"
            key="maintain_email"
          >
            <h-tooltip content="一般为实施、维护邮箱">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.maintain_email"
              placeholder="请输入"
              style="width: 280px"
              :maxlength="50"
            ></h-input>
          </h-form-item> -->
          <h-form-item
            label="到期日期"
            prop="service_end_time"
            required
            key="service_end_time"
          >
            <h-tooltip>
              <h-icon name="feedback"></h-icon>
              <div slot="content">
                <p>许可证书截止有效日期，许可证书生成后立即生效，</p>
                <p>
                  到期后七天内仍可以继续使用，系统会每天短信/邮件提醒系统操作员
                </p>
              </div>
            </h-tooltip>
            <h-date-picker
              type="date"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              v-model="formColsMarket.service_end_time"
              showFormat
              :options="options2"
              style="width: 280px"
            ></h-date-picker>
          </h-form-item>
          <!-- <h-form-item
            label="客户渠道"
            prop="customer_channels"
            v-if="formColsMarket.certificate_type != 5"
            key="customer_channels"
          >
            <h-tooltip content="来自哪个渠道，资源/云赢/交易所/风控等">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-select
              v-model="formColsMarket.customer_channels"
              style="width: 280px"
            >
              <h-option
                v-for="item in marketList"
                :key="item.dict_item_code"
                :value="item.dict_item_code"
                >{{ item.dict_item_name }}</h-option
              >
            </h-select>
          </h-form-item> -->
          <h-form-item
            label="工具类型"
            prop="tool_type"
            v-if="formColsMarket.certificate_type == 6"
            key="tool_type"
            required
          >
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-select
              v-model="formColsMarket.tool_type"
              style="width: 280px"
              multiple
              isString
            >
              <h-option v-for="item in toolList" :key="item" :value="item">{{
                item
              }}</h-option>
            </h-select>
          </h-form-item>
          <h-form-item
            label="允许的业务"
            prop="business"
            required
            v-if="formColsMarket.certificate_type == 1"
            key="business"
          >
            <h-tooltip content="允许的业务，如上海level1，深圳五代">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-select
              v-model="formColsMarket.business"
              style="width: 280px"
              multiple
            >
              <h-option
                v-for="item in businessList"
                :key="item.key"
                :value="item.key"
                >{{ item.name }}</h-option
              >
            </h-select>
          </h-form-item>
          <h-form-item
            label="市场列表"
            prop="certificate_market"
            required
            v-if="
              formColsMarket.certificate_type != 1 &&
                formColsMarket.certificate_type != 5 &&
                formColsMarket.certificate_type != 6
            "
            key="certificate_market"
          >
            <h-tooltip content="许可证书允许行情服务访问的市场列表">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-select
              v-model="formColsMarket.certificate_market"
              style="width: 280px"
              multiple
            >
              <h-option
                v-for="item in certificateList"
                :key="item.certificate_market_id"
                :value="item.certificate_market_number"
                >{{ item.certificate_market_name }}</h-option
              >
            </h-select>
          </h-form-item>

          <h-form-item
            label="证书名称"
            prop="certificate_name"
            required
            key="certificate_name"
          >
            <h-tooltip content="该许可证书的名称，作为许可证书的唯一标识">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.certificate_name"
              placeholder="请输入"
              :maxlength="64"
              style="width: 280px"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="最大在线数"
            prop="per_value"
            :required="formColsMarket.certificate_type=='3'"
            v-if="
              formColsMarket.certificate_type == '1' ||
                formColsMarket.certificate_type == '2' ||
                formColsMarket.certificate_type == '3'
            "
            key="per_value"
            :validRules="regRule"
          >
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model.trim="formColsMarket.per_value"
              :placeholder="formColsMarket.certificate_type=='3'?'单个HDF在线数不超过8':'请输入'"
              style="width: 280px"
              specialFilter
              :specialDecimal="0"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="证书环境"
            prop="certificate_environment"
            v-if="
              formColsMarket.certificate_type != 4 &&
                formColsMarket.certificate_type != 5
            "
            key="certificate_environment"
          >
            <h-tooltip content="开发，测试">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-select
              v-model="formColsMarket.certificate_environment"
              style="width: 280px"
            >
              <h-option value="1">测试环境</h-option>
              <h-option value="2">生产环境</h-option>
            </h-select>
          </h-form-item>

          <h-form-item
            label="异动监控接入服务器名称"
            prop="abnormal_server_name"
            required
            key="abnormal_server_name"
            v-if="formColsMarket.certificate_type == 4"
          >
            <h-tooltip content="最多50个字符">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.abnormal_server_name"
              placeholder="请输入"
              :maxlength="50"
              style="width: 280px"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="异动监控接入服务器ID"
            prop="abnormal_server_id"
            key="abnormal_server_id"
            v-if="formColsMarket.certificate_type == 4"
          >
            <h-tooltip content="最多50个字符">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.abnormal_server_id"
              placeholder="请输入"
              :maxlength="50"
              style="width: 280px"
              @on-blur="
                formColsMarket.abnormal_server_id = formColsMarket.abnormal_server_id.trim()
              "
            ></h-input>
          </h-form-item>

          <h-form-item
            label="合同编号"
            prop="contract_id"
            style="font-size:0"
            key="contract_id"
          >
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model="formColsMarket.contract_id"
              placeholder="请输入"
              style="width: 280px;height:32px;"
              :maxlength="50"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="合同金额"
            prop="contract_amount"
            key="contract_amount"
            :validRules="amountVali"
          >
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model="formColsMarket.contract_amount"
              placeholder="请输入"
              style="width: 280px"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="IP地址"
            prop="ip_address"
            :required="formColsMarket.certificate_type !== 3"
            v-if="formColsMarket.certificate_type == 3"
            key="ip_address"
            cols="2"
          >
            <h-tooltip content="目前可同时输入多个ip，ip间用英文”,”分隔">
              <h-icon name="feedback"></h-icon>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.ip_address"
              :placeholder="
                formColsMarket.certificate_type == 3
                  ? '同时输入多个ip，ip间用英文”,”分隔，MAC和IP选填一个选项'
                  : '同时输入多个ip，ip间用英文”,”分隔'
              "
              style="width: 780px"
              showWordLimit
              type="textarea"
              :maxlength="2500"
            ></h-input>
          </h-form-item>
          <h-form-item
            label="MAC地址"
            prop="mac_address"
            :required="formColsMarket.certificate_type !== 3"
            v-if="
              formColsMarket.certificate_type == 3 ||
                formColsMarket.certificate_type != 5
            "
            cols="2"
          >
            <h-tooltip>
              <h-icon name="feedback"></h-icon>
              <div slot="content">
                <p>MAC地址，格式：</p>
                <p>xx:xx:xx:xx:xx:xx，多</p>
                <p>个mac地址使用英文逗</p>
                <p>号隔开</p>
              </div>
            </h-tooltip>
            <h-input
              v-model="formColsMarket.mac_address"
              :placeholder="
                formColsMarket.certificate_type == 3
                  ? 'MAC地址格式：xx:xx:xx:xx:xx:xx，多个mac地址使用英文逗隔开， MAC和IP选填一个选项'
                  : 'MAC地址格式：xx:xx:xx:xx:xx:xx，多个mac地址使用英文逗隔开'
              "
              style="width: 780px"
              :maxlength="2000"
              showWordLimit
              type="textarea"
            ></h-input>
          </h-form-item>
          <h-form-item label="备注" prop="remark" cols="2">
            <h-icon name="feedback" style="opacity:0"></h-icon>
            <h-input
              v-model="formColsMarket.remark"
              placeholder="请输入"
              type="textarea"
              :showWordLimit="true"
              :maxlength="500"
              style="width: 780px"
            ></h-input>
          </h-form-item>

        </h-form>
        <div
        class="agreement_box"
        id="agreement_box"
        v-if="service_info.clause_description"
      >
      <span class="form-left-label pr-8">
        <span class="form-required">*</span>服务协议</span>
        <h-checkbox v-model="checkClause" @click.prevent.native="checkClauseBtn"></h-checkbox
          ><a href="javascript:;" @click="openClause">《{{service_info.template_name||'服务特定条款'}}》</a>
        <span>请您阅读并同意产品相关使用协议后打勾</span>
      </div>
      </div>
      <!-- <div class="btn-wrapper">
        <h-button  type="ghost" @click="goBack" style="width:102px">返回</h-button>
        <h-button type="primary" @click="ok();setGio()" style="width: 102px"
        :disabled="disabled">提交审核</h-button
        >
      </div> -->

    </div>
    <div class="footer_box" id="footer_box">
      <div class="foot-content">
        <div>
          <h-button class="back-btn" type="ghost" @click="goBack">返回</h-button>
          <h-button type="primary" @click="ok();setGio()" style="width: 102px" :disabled="disabled">提交审核</h-button>
        </div>
      </div>
    </div>
    <h-msg-box
      title="新建KEY"
      v-model="createKeyShow"
      class-name="vertical-center-modal"
      :top="100"
      width="440"
      height="170"
      cols="1"
    >
      <h-form
        :model="keyInfo"
        label-position="right"
        :label-width="90"
        ref="keyForm"
        @submit.native.prevent
      >
        <h-form-item label="环境" required prop="environment">
          <!-- <h-select v-model="keyInfo.environment" style="width: 270px">
            <h-option
              v-for="item in envList"
              :value="item.value"
              :key="`addenv${item.value}`"
              >{{ item.label }}</h-option
            >
          </h-select> -->
          {{ environment_type == "2" ? "生产环境" : "测试环境" }}
        </h-form-item>
        <h-form-item label="应用名称" required prop="client_name">
          <h-input
            v-model="keyInfo.client_name"
            style="width: 270px"
            @on-enter="enter"
          ></h-input>
        </h-form-item>
      </h-form>
      <p slot="footer" style="display: flex; justify-content: center">
        <h-button type="primary" @click="infoOk">确定</h-button>
        <h-button type="ghost" @click="infoCancel">取消</h-button>
      </p>
    </h-msg-box>
    <h-msg-box
      v-model="successShow"
      class-name="vertical-center-modal"
      :top="100"
      width="440"
      cols="1"
    >
      <p slot="header">
        <h-icon name="success" style="color: #1abe6b"></h-icon>
        <span>申请成功</span>
      </p>
      <p>
        感谢您的申请，我们会在一个工作日内反馈审核结果，审核期间可能会联系您，请保持联系方式畅通！
      </p>
      <p slot="footer" style="display: flex; justify-content: space-evenly">
        <h-button type="primary" @click="tabClick(1)"
          >返回服务市场</h-button
        >
        <h-button type="primary" @click="tabClick(2)" style="width: 102px"
          >查看申请</h-button
        >
      </p>
    </h-msg-box>

    <h-msg-box
      title=" "
      v-model="clauseShow"
      class-name="clause-center-modal"
      :top="100"
      width="800"
      height="450"
      maxHeight="700"
      cols="1"
      :mask-closable="false"
      maximize
    >
      <div class="clause_box" v-html="service_info.clause_description"></div>
      <p class="clause_footer" slot="footer">
        <h-button :disabled="countdown>0?true:false" type="primary" @click="confirmMethod">我已阅读（{{countdown}}s）</h-button>
      </p>
    </h-msg-box>

    <identity-check
      :show.sync="showIdentityModel"
      @success="continueSubmitOrder"
    ></identity-check>
  </div>
</template>
<script>
import IdentityCheck from "./components/IdentityCheck.vue";
import HPanel from "@/components/HPanel";
import UploadItem from "@/views/frontViews/uploadItem";
import {
  queryDictItem,
  comboxList,
  detail,
  fsearch,
  addClient,
  applyService,
  queryCertificateBusiness,
  queryCertificateMarket,
  judgeCertificateName,
  getChargeInfo,
  getUserAgent,
  getServiceAgreementRecord,
  addServiceAgreementRecord
} from "@/api/service.js";
import Cookies from 'js-cookie'
import { getFormatDate, getCamelCase } from "@/utils";
import _ from "lodash";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "ServiceApply",
  components: {
    UploadItem,
    IdentityCheck
  },
  data() {
    const _this = this;
    let isEmail = value => {
      let patrn = /^([0-9a-zA-Z])+([0-9a-zA-Z\-_\\.\\+~])*@([0-9a-zA-Z])+([\\-][0-9a-zA-Z]+)*([\\.][0-9a-zA-Z]+([\\-][0-9a-zA-Z]+)*){1,8}$/;
      if (value === "" || value === null) {
        return false;
      } else if (!patrn.exec(value)) {
        return false;
      }
      return true;
    };
    const validateEmail = (rule, value, callback) => {
      if (value && !isEmail(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      let telReg = /^0(\d{2,3})-?\d{7,8}(-\d{1,5}){0,3}$|^1\d{10}$|^852-?[2689]\d{7}$|^852-?3[014-9]\d{6}$|^852-?3[23]\d{7}$|^852-?5[0-578]\d{6}$|^852-?5[69]\d{7}$|^853-?[1-9]\d{7}$/;

      if (!value) {
        callback(new Error("请输入联系电话"));
      } else if (!telReg.test(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    const validateIp = (rule, value, callback) => {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/;
      if (value.trim() == "" && _this.formColsMarket.certificate_type != 3) {
        callback(new Error("输入不能为空"));
      } else {
        if (value.trim() == "") {
          callback();
          return;
        }
        // 分割ip地址
        let val = value.split(",");
        for (var i = 0; i < val.length; i++) {
          if (!reg.test(val[i])) {
            callback(new Error(`此ip:${val[i]}不符合ip规则，请确认ip格式！`));
          }
        }
        callback();
      }
    };
    // const validatePerValue = (rule, value, callback) => {
    //   if (value.trim() == "") {
    //     return callback(new Error("tps限制值不能为空"));
    //   } else if (!value && value != 0 && value != "0") {
    //     return callback(new Error("tps限制值不能为空"));
    //   } else {
    //     if (!/^[0-9]*$/.test(value)) {
    //       return callback(new Error("请输入数字"));
    //     } else if (typeof Number(value) == "number" && value > 100000) {
    //       return callback(new Error("请输入小于100000的数字"));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    const validatePerValue = (rule, value, callback) => {
      let reg = /^([1-9]\d{0,4}|100000)$/
      if (_this.formColsMarket.certificate_type == '3'&&+value>8) {
        callback(new Error("单个HDF在线数不超过8"));
      } else if(_this.formColsMarket.certificate_type != '3'){
        if(value&&!reg.test(value)){
          callback(new Error("1-10万之间的整数"));
        }
        callback();
      }else{
        callback();
      }
    };
    const validateEDate = (rule, value, callback) => {
      if (this.formCols.service_start_time == "") {
        return callback(new Error("有效期不能为空"));
      } else {
        if (
          new Date(this.formCols.service_start_time) >
          new Date(this.formCols.service_end_time)
        ) {
          return callback(new Error("不能大于结束有效期"));
        } else {
          callback();
        }
      }
    };
    const validateFDate = (rule, value, callback) => {
      if (this.formCols.service_end_time == "") {
        return callback(new Error("有效期不能为空"));
      } else {
        if (
          new Date(this.formCols.service_end_time) <
          new Date(this.formCols.service_start_time)
        ) {
          return callback(new Error("不能小于开始有效期"));
        } else {
          callback();
        }
      }
    };
    const validateName = (rule, value, callback) => {
      if (value.trim() == "") {
        return callback(new Error("证书名称不能为空"));
      } else {
        judgeCertificateName({ certificate_name: value })
          .then(res => {
            if (res.error_code == 0) {
              callback();
            } else {
              return callback(new Error(res.error_info));
            }
          })
          .catch(res => {
            return callback(new Error("证书名称不可用"));
          });
      }
    };
    const validateMAC = (rule, value, callback) => {
      let reg1 = /^[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}$/;
      if (value.trim() == "" && _this.formColsMarket.certificate_type != 3) {
        callback(new Error("输入不能为空"));
      } else {
        if (value.trim() == "") {
          callback();
          return;
        }
        // 分割mac地址
        let val = value.split(",");
        for (var i = 0; i < val.length; i++) {
          if (!reg1.test(val[i])) {
            callback(
              new Error(
                `此MAC:${val[i]}不符合mac规则，请确认xx:xx:xx:xx:xx:xx！`
              )
            );
          }
        }
        callback();
      }
    };


    return {
      showIdentityModel: false, //子账号身份校验
      service_info:{},
      owner_account_type:"1",
      owner_account_id: "",//下单账号id
      supportEnterprise: false, //产品是否支持企业和个人下单 1个人，2企业
      durationTime: 0, //快捷时间
      // 使用state来阻止后面的代码执行
      state: false,
      formCols: {
        service_name: "",
        service_id: this.$route.params.id,
        serial_no: this.$route.params.cid,
        app_scene: "",
        use_object: "0",
        customer_name: "",
        customer_contact: "",
        customer_contact_tel: "",
        customer_contact_email: "",
        environment: "",
        authorization_mode: "",
        appkey: "",
        per_value: "",
        apply_basis: "",
        contract_id: "",
        contract_amount: "",
        // service_end_time: "",
        // service_start_time: "",
        alternation_type: "",
        alternation_id: "",
        set_meal_str: "" //套餐
      },
      applyBasisList: [],
      appkeyList: [],
      service_id: this.$route.params.id,
      charge_id: this.$route.params.cid,
      options: [],
      loading: false,
      loadingText: "正在加载中...",
      createKeyShow: false,
      successShow: false,
      keyInfo: {},
      options1: {
        disabledDate(date) {
          return date && date.valueOf() > new Date("2069-12-06 00:00:00");
        }
      },
      ruleValidate: {
        // per_value: [{ validator: validatePerValue, trigger: "blur" }],
        // service_start_time: [{ validator: validateEDate, trigger: "change" }],
        // service_end_time: [{ validator: validateFDate, trigger: "change" }],
        customer_contact_tel: {
          required: false,
          validator: validatePhone,
          trigger: "blur"
        },
        customer_contact_email: {
          required: false,
          validator: validateEmail,
          trigger: "blur"
        }
      },
      environment_type: "",
      envList: [],
      regRule: [
        {
          test: validatePerValue,
          trigger: "blur",
        },
      ],
      isType: "", //交付方式类型
      formColsMarket: {
        //行情证书
        service_id: this.$route.params.id,
        serial_no: this.$route.params.cid,
        certificate_type: 1, //申请证书类型
        mac_address: "", //MAC地址
        ip_address: "", //ip
        use_object: "0", //使用对象-页面隐藏，默认传参
        customer_name: "", //客户名称
        applicant_email: "", //申请人邮箱
        maintain_email: "", //对接工程邮箱
        certificate_environment: "", //环境
        business: [], //业务
        per_value: "",
        certificate_market: [], //市场
        certificate_name: "", //证书名称
        customer_channels: "", //客户渠道
        service_end_time: "", //到期日期
        contract_amount: "", //合同金额
        contract_id: "", //合同流程编号
        abnormal_server_id: "", //异动监控接入服务器ID
        abnormal_server_name: "", //异动监控接入服务器名称
        certificate_detail: "", //证书详情
        app_scene: "",
        remark: "",
        tool_type: ""
      },
      toolList: [
        "quote_decoder",
        "demo_recv",
        "sailfish_pro",
        "decode_tool_aos",
        "send_tool",
        "rebuild_service",
        "sailfish",
        "l2plus"
      ], //工具类型
      certificateTypeLlist: [
        //证书类型
        { id: 1, label: "ds" },
        { id: 2, label: "cloud（hq）" },
        { id: 3, label: "hdf" },
        { id: 4, label: "monitor" },
        { id: 5, label: "H5API" },
        { id: 6, label: "NSQ" }
      ],
      marketList: [
        //客户渠道
        // { id: 1, label: "资管" },
        // { id: 2, label: "风控" },
        // { id: 3, label: "云永" },
        // { id: 4, label: "云纪" },
        // { id: 5, label: "鲸腾" },
        // { id: 6, label: "交易所事业部" },
        // { id: 7, label: "银行事业部" },
        // { id: 8, label: "数据运营中心" },
        // { id: 9, label: "内部测试" },
        // { id: 10, label: "聚源" },
        // { id: 11, label: "财富经纪" }
      ],
      businessList: [], //允许的业务
      certificateList: [], //市场列表
      nameIsCanUse: false, //证书名称是否可用
      ruleValidateMarket: {
        certificate_name: [{ validator: validateName, trigger: "blur" }],
        mac_address: [{ validator: validateMAC, trigger: "blur" }],
        ip_address: [{ validator: validateIp, trigger: "blur" }],
        applicant_email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        maintain_email: [
          { message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ]
      },
      options2: {
        disabledDate(date) {
          return (
            date &&
            date.valueOf() <=
              new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)
          );
        }
      },
      amountVali: [
        {
          test: /^(([0-9]|([1-9][0-9]{0,8}))((\.[0-9]{2})?))$/,
          message: "0到9位正整数小数点保留两位",
          trigger: "blur"
        }
      ],
      owner_account_type: "1",
      owner_account_id: "", //下单账号id
      ownerList:[],
      checkClause: false,
      clauseShow:false,
      countdown:10,
      refreshInterval:null,
      isReaded:false,
      agreementStatus:false
    };
  },
   computed: {
    ...mapGetters(["loginInfo"]),
    disabled() {
      if (this.service_info.clause_description && !this.checkClause) {
        return true;
      } else {
        return false;
      }
    },
   },
  created() {
    let newUrl = `/subscription-center/packageConfirm?sid=${this.service_id}&pid=${this.charge_id}`
    location.href = newUrl
    return

    let user = this.$store.getters.user;
    this.formCols.department = user.department;
    this.formCols.companyContacts = user.company_contacts;
    this.formColsMarket.companyContacts = user.company_contacts;
    this.formColsMarket.department = user.department;
    this.getDict();
    this.getDicCustomerChannel();
    this.getBusiness();
    this.getCertificateList();
    this.getServiceAgreementRecord();

    let that = this;
    // this.formCols.environment = this.$route.params.environment_type;
    detail(this.service_id).then(res => {

      this.getOwnerList(res.service_id,this.charge_id)
      that.isType = res.alternation_id;
      that.service_info = res;
      this.buyAcitivty();
      this.formCols.authorization_mode=res.authorization_mode;
      if (that.isType == "15") {
        that.formColsMarket.alternation_id = res.alternation_id;
        that.formColsMarket.alternation_type = res.alternation_type;
      } else {
        this.formCols.service_name = res.service_name;
        this.formCols.alternation_id = res.alternation_id;
        this.formCols.alternation_type = res.alternation_type;

        //add by wyy 增加套餐环境字段的判断，key只能选择当前环境的key
        let chargeList = res.service_charge_list;
        if (chargeList.length > 0) {
          chargeList.forEach(element => {
            //
            if (element.serial_no == that.$route.params.cid) {
              this.environment_type = element.environment_type;
              this.formCols.environment = element.environment_type;
              let obj = {
                value: element.environment_type,
                label: element.environment_type == "2" ? "PRD" : "UAT"
              };
              let environment =
                element.environment_type == "2" ? "生产环境" : "测试环境";
              this.envList.push(obj);
            }
          });
        }
        this.getCombo();
      }
    });
  },
  methods: {
    getServiceAgreementRecord(){
      getServiceAgreementRecord({
        service_id:this.service_id
      }).then((res)=>{
        this.agreementStatus = res || false;
        if(res){
          this.isReaded = true
          this.countdown = 0;
        }
      })
    },
     getOwnerList(service_id,servicePackageId){
      getUserAgent({
        service_id:service_id,
        service_package_id:servicePackageId
      }).then((res)=>{
        if(res&&res.length){
          this.ownerList = res || []
          this.owner_account_id = res[0].account_id
          this.owner_account_type = res[0].account_type
        }else{
          this.ownerList=[]
        }
        this.getCombo();
      })
    },
    changeOwner(account_id, type) {
      this.owner_account_id = account_id;
      this.owner_account_type = type;
      this.getCombo();
    },
    setGio() {
      try {
        this.gioTrackEvent("UMod_clickSubmit", {
          submitType_var:'申请',
          moduleParm_var:this.formCols.set_meal_str,
          moduleId_var: this.service_id,
          moduleName_var: this.formCols.service_name,
        });
      } catch (e) {
        console.log(e);
      }
    },
    buyAcitivty() {
      getChargeInfo(this.formCols.serial_no)
        .then(res => {
          let notInType =
            ["1", "2", "3", "4", "5", "6", "7", "8", "10", "11", "12","16"].indexOf(
              this.service_info.alternation_id
            ) == -1;
          let set_meal_str = "";
          if (res.suite_name != "--") {
            set_meal_str += res.suite_name ;
          }
           if (res.suite_name&&res.suite_name != "--"&&this.service_info.alternation_id!= "7" &&!notInType) {
            set_meal_str +='：' ;
          }
          let comboType = "",
            aid = this.service_info.alternation_id;
          let val =
            aid == "6"
              ? "人数"
              : aid == "8"
              ? "人次"
              : aid == "4"
              ? "账号数"
              : "次数";
          comboType = val;
          let showEnv = false;
          if (
            this.service_info.alternation_id == "1" ||
            this.service_info.alternation_id == "3" ||
            this.service_info.alternation_id == "11"
          ) {
            showEnv = true;
            set_meal_str +=
              res.environment_type == "2" ? "生产环境" : "测试环境";
            set_meal_str += " / ";
          }
          if (
            this.service_info.alternation_id != "12" &&
            this.service_info.alternation_id != "10" &&
            this.service_info.alternation_id != "7" &&
            this.service_info.alternation_id != "2" &&
            this.service_info.alternation_id != "16" &&
            !notInType
          ) {
            set_meal_str +=
              this.hanlderVal(res.invoke_times) + "" + comboType + " / ";
          }
          if (this.service_info.alternation_id != "7" && !notInType) {
            set_meal_str += this.hanlderVal(res.used_length) + "天";
          }
          if (res.peak_value && res.peak_value != -1 && showEnv) {
            set_meal_str += `，峰值：${res.peak_value}次/秒`;
          }
          this.formCols.set_meal_str = set_meal_str;
        })
        .catch(err => {});
    },
    hanlderVal(val) {
      return val == 0 || val == -1 ? "不限" : val;
    },
    // 格式化时间
    selfFormatDate(timer) {
      const year = timer.getFullYear();
      const month = timer.getMonth() + 1;
      const day = timer.getDate() > 9 ? timer.getDate() : "0" + timer.getDate();
      const time = year + "-" + month + "-" + day;
      return time;
    },
    //允许的业务
    getBusiness() {
      queryCertificateBusiness().then(res => {
        this.businessList = res;
        this.businessList.forEach((item, index) => {
          this.$set(item, "key", index + "");
        });
      });
    },
    //市场列表
    getCertificateList(v) {
      queryCertificateMarket({
        market_type: v || this.formColsMarket.certificate_type
      }).then(res => {
        this.certificateList = res;
      });
    },
    //行情证书类型改变
    changeCertificateType(v) {
      this.formColsMarket.per_value = "";
      this.getCertificateList(v);
    },
    enter() {
      return false;
    },
    tabClick(type) {
      if (type == 1) {
        //this.$router.push()
        window.location.href = "/openplat-front/serviceProductAll";
      } else {
        sessionStorage.setItem('ApplicationTab','1')
        window.location.href = "/cloud-console/trade/myApplication";
      }
    },
    goBack(){
      history.back()
    },
    getCombo() {
      this.getComboxList(this.environment_type);
    },
    remoteMethod: _.debounce(function(query) {
      if (query !== "") {
        this.loading = true;
        this.queryCompany(query);
      } else {
        this.options = [];
      }
    }, 500),
    queryCompany(query) {
      fsearch(query)
        .then(res => {
          this.options = res;
          this.loading = false;
        })
        .catch(error => {});
    },
    ok() {
      if (
        this.formColsMarket.certificate_type == 3 &&
        this.formColsMarket.ip_address === "" &&
        this.formColsMarket.mac_address === ""
      ) {
        this.$hMessage.error(
          "申请证书类型为hdf时，ip地址和MAC地址必须选填一个",
          5000
        );
        return;
      }
      if (this.formCols.alternation_type != 1) {
        delete this.formCols.environment;
      }
      let that = this;
      let str = "";
      that.isType == "15" ? (str = "formColsMarket") : (str = "formCols");
      that.$refs[str].validate(valid => {
        this.state = true;
        if (valid) {
          // 当前订单归属账号为企业 且 当前登录账号非企业管理员 则显示管理员二次校验弹窗
          if (
            this.owner_account_type == '2' &&
            this.loginInfo.enterprise_account &&
            this.loginInfo.personal_account.account_id !=
              this.loginInfo.enterprise_account.admin_personal_account_id
          ) {
            this.showIdentityModel = true;
            return;
          }
          this.confirmSubmitOrder()
        }
        this.state = false;
      });
    },
    //弹框后继续下单
    continueSubmitOrder() {
      this.showIdentityModel = false;
      this.confirmSubmitOrder();
    },
    // 提交申请
    confirmSubmitOrder () {
      const that = this
      let params = {};
      let formData = new FormData();
      if (that.isType != 15) {
        that.formCols.use_object = "0";
        that.formCols.apply_record_source = 1;
        let list = that.$refs.uploadItem.inputImgIlist;
        for (var i = 0; i < list.length; i++) {
          formData.append("file", list[i]);
        }
        for (let key in that.formCols) {
          formData.append(getCamelCase(key), that.formCols[key]);
        }
      } else {
        let newArr = this.businessList.filter(item => {
          return this.formColsMarket.business.indexOf(item.key) !== -1;
        });
        let adapterArr = [];
        let businessArr = [];
        let keyArr = [];
        newArr.forEach(item => {
          adapterArr.push(item.adapter);
          if (item.business) businessArr.push(item.business);
          keyArr.push(item.key);
        });
        let str1 =
          adapterArr.toString() +
          ";" +
          businessArr.toString() +
          ";" +
          keyArr.toString();
        params = JSON.parse(JSON.stringify(that.formColsMarket));
        params.certificate_market = params.certificate_market.toString();
        params.use_object = "0";
        if (this.formColsMarket.certificate_type != 6) {
          params.business = str1;
        } else {
          params.business = "";
        }

        for (let key in params) {
          formData.append(getCamelCase(key), params[key]);
        }
      }
      formData.append('accountId', this.owner_account_id);
      formData.append('accountType', this.owner_account_type);

      axios({
        url: "/openplat-gateway/openplat/openplat-service-server/v/service/applyService",
        data: formData,
        method: "post",
        headers: {
          "content-type": "multipart/form-data",
          "Access-Token":
            sessionStorage.getItem("Access-Token") ||
            localStorage.getItem("Access-Token") ||
            Cookies.get("Access-Token")
        },
        withCredentials: true
      })
        .then(res => {
          if (res.data.error_code && res.data.error_code != "0") {
            that.$hMessage.error(res.data.error_info, 3000);
          } else {
            that.successShow = true;
          }
        })
    },
    cancel() {},
    infoOk() {
      this.$refs["keyForm"].validate(valid => {
        if (valid) {
          let data = {
            environment: this.keyInfo.environment,
            client_name: this.keyInfo.client_name,
            account_id:this.owner_account_id
          };
          addClient(data)
            .then(res => {
              if (res === null) {
                this.$hMessage.success("您已成功成功创建应用！");
                this.createKeyShow = false;
                this.getComboxList(this.keyInfo.environment, "selected");
                this.formCols.environment = this.keyInfo.environment;
              }
            })
            .catch(error => {});
        }
      });
    },
    infoCancel() {
      this.createKeyShow = false;
    },
    getDict() {
      queryDictItem("apply_basis")
        .then(res => {
          this.applyBasisList = res;
        })
        .catch(error => {});
    },
    getDicCustomerChannel(){
      queryDictItem("market_customer_channel")
        .then(res => {
          this.marketList = res;
        })
        .catch(error => {});
    },
    createKey() {
      this.keyInfo = Object.assign({}, {});
      this.keyInfo.environment = this.formCols.environment
        ? this.formCols.environment
        : "";
      this.$refs.keyForm.resetFields();
      this.createKeyShow = true;
    },
    getComboxList(env, type) {
      if (this.formCols.alternation_type !== "1") {
        return;
      }
      if (!env) return;
      if (!this.owner_account_id) return;
      comboxList(env,this.owner_account_id)
        .then(res => {
          this.appkeyList = res;
          if (type == "selected") {
            this.$nextTick(() => {
              this.formCols.appkey = res[0].app_key;
            });
          }
        })
        .catch(error => {});
    },
    checkClauseBtn(val){
      if(this.checkClause){
        this.checkClause = false
      }else{
        if(this.agreementStatus){
          this.checkClause = true
        }else{
          this.checkClause = false
          this.openClause()
        }
      }
    },
    // 打开服务条款
    openClause: _.debounce(function () {
      this.refreshInterval&&clearInterval(this.refreshInterval);
        if(!this.isReaded)  this.countdown = 10
        this.clauseShow = true;
        this.refreshInterval = setInterval(() =>{
          if (this.countdown >0) {
          this.countdown--;
          }else{
            clearInterval(this.refreshInterval);
          }
      }, 1000);
    }, 200),
    // 条款我已阅读
    confirmMethod(){
      this.clauseShow = false;
      this.checkClause = true;
      this.isReaded = true;
      addServiceAgreementRecord({
        service_id:this.service_id
      }).then(()=>{
        this.getServiceAgreementRecord();
      })
    },
  }
};
</script>
<style lang="scss" scoped>
  .form-required{
    color: #f5222d;
    margin-right: 2px;
    font-family: SimSun, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
  }
.h-radio-group {
  display: flex;
  .h-radio-wrapper {
    border: 1px solid #d7dde4;
    padding: 0px 4px;
    margin-right: 0;
    height: 26px;
    line-height: 26px;
    border-left: 0;
  }
  .cur-radio {
    border: 1px solid #4686f2 !important;
  }
  .h-radio-wrapper:nth-child(1) {
    border-left: 1px solid #d7dde4;
  }
}
.content-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 9px 0;
}
.apply-form-wrapper {
  width: 1200px;
  padding-bottom: 70px;
  background: #fff;
  margin: 0 auto;
  .apply-form {
    width: 1000px;
    margin: 0 auto;
    padding: 25px 0;
  }
  .btn-wrapper {
    width: 300px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }
}
.red-tip {
  color: red;
  white-space: nowrap;
}
/deep/ .h-input-word-limit {
  height: 30px;
}
/deep/ .showWordLimit .h-input {
  padding-right: 52px;
}
.page-apply {
}
.owner-item {
  display: inline-block;
  text-align: center;
  min-height: 36px;
  background: #fff;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  color: #606266;
  letter-spacing: 0;
  line-height: 14px;
  margin-bottom: 10px;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 8px;
}
.owner-item-active {
  border: 1px solid #3b6bfa;
  color: #3b6bfa;
  cursor: pointer;
}
.owner-wrap {
  margin: 20px 0 0 0;
}
.form-left-label{
  width: 122px;
  display: inline-block;
  text-align: right;
}
.pr-8{
  padding-right: 8px;
}
.agreement_box{
  padding: 5px 0;
}

.footer_box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  z-index: 99;
  .foot-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: end;
    align-items: center;
    height: 100%;
    .foot-left {
      display: flex;
    }
    .yellow {
      // height: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 600;
    }
    .unit {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
      margin-right: 4px;
    }
    .price {
      height: 28px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
    }
    .discount {
      height: 17px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 400;
      display: block;
      text-align: right;
    }
  }
  .back-btn {
    width: 100px;
  }
  .confirm-btn {
    width: 100px;
  }
}
</style>
<style lang="scss">
.h-modal-body .tip {
  font-size: 12px;
  color: #999999;
  line-height: 18px;
  margin-top: 8px;
}
.h-input-wrapper textarea.h-input {
  padding-right: 66px;
}
.apply-form .formColsMarket .h-tooltip-content .h-tooltip-inner {
  max-width: 400px;
}
.apply-form .formColsMarket .h-form-item-label {
  padding: 0;
}
.apply-form .formColsMarket .verify-tip > .verify-tip-inner {
  max-width: 300px !important;
}
</style>
<style>
  .vertical-center-modal {
    display: flex;
    align-items: center;
  }
  .clause_box{
    border: 1px solid #ddd;
    padding: 4px 10px;
    overflow: auto;
  }
  .clause_footer{
    margin:0 auto ;
    text-align: center;
  }
  .clause-center-modal .h-modal-body{
    padding: 16px 32px;
  }
  </style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/serviceApply.vue